import { fetchFileAsBlob } from '~/utils/fetchFileAsBlob';

// Revoking a blob URL synchronously after `link.click()` can cancel the browser download for larger
// files (common for inbound WhatsApp PDFs). Defer cleanup instead of revoking immediately.
const BLOB_URL_REVOKE_DELAY_MS = 60_000;

export const downloadFile = async ({ mimeType, name, route }: { route: string; name: string; mimeType?: string }) => {
    const { blobUrl, fileName } = await fetchFileAsBlob({ mimeType, route });

    // Create and trigger download
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = fileName ?? name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.setTimeout(() => URL.revokeObjectURL(blobUrl), BLOB_URL_REVOKE_DELAY_MS);
};
